// extracted by mini-css-extract-plugin
export default {"welcomeContainer":"IntroSection_welcomeContainer__kBcgF","introductionPaper":"IntroSection_introductionPaper__IOewl"};